import { createFileRoute, redirect } from '@tanstack/react-router'
import { AccountDetails } from '../../../../features/serviceManagement/accounts/AccountDetails.tsx'

export const Route = createFileRoute('/_app/smp/accounts/$customerId')({
	component: AccountDetails,
	loader: async ({ context: { customers }, params }) => {
		const customer = customers.find((customer) => customer.id === params.customerId)
		if (!customer) {
			throw redirect({ to: '/smp/accounts' })
		}
		return { customer }
	},
})
